module.exports = __webpack_public_path__ + "desing.0b135c52dd7b336a2e28.png";


//////////////////
// WEBPACK FOOTER
// C:/Users/Artem/Desktop/Programming/studio/creativeDigital/src/assets/elements/desing.png
// module id = ../../../../../src/assets/elements/desing.png
// module chunks = 0